export default __webpack_public_path__ + "static/media/video-time.4d0465c7.svg";